'use strict';

var angular = require('angular');
var dependencies = ['AVRO.ChartControlsBoard'];
module.exports = angular.module('AVRO.ReferencesButtons', dependencies).directive('rmReferencesButtons', require('./directives/ReferencesButtonsDirective'));